import { Skeleton } from '@/components/ui'
import { ListaUltimosAtendimentosSkeleton } from '@/features/atendimento/shared/components'
import { ConsulteEmpreendimentosHero } from '@/features/atendimento/shared/components/consulte-empreendimentos-hero'

export const UltimosAtendimentosPageSkeleton = () => {
  return (
    <div className="bg-foreground mx-auto px-6 py-8 sm:max-w-4xl" data-testid="ultimos-atendimentos-skeleton">
      <ConsulteEmpreendimentosHero />
      <div className="mb-6 flex items-center justify-between">
        <Skeleton className="h-7 w-58" />
      </div>
      <ListaUltimosAtendimentosSkeleton />
    </div>
  )
}
